import React, { ReactNode } from 'react';
import { useFormik } from 'formik';

import {
  Row,
  Col,
  Button,
  Modal,
  Form,
} from 'react-bootstrap';
import styled from 'styled-components';

import { Spin, Alert } from 'antd';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../utils/store.tsx';
import slice, { fields, FormikContext, initialValues, formSchema } from './slice.tsx';
import { checkStatus } from '../../slice.tsx';

// enums
// import {  } from '../../../../utils/utils.tsx';
// import {  } from '../../../../utils/enums.tsx';

import { ReactComponent as AlertTriangleIcon } from "../../../../assets/icons/alert-triangle.svg";

// ----------------------------------------------------------------------

const StyledModal = styled(Modal)`
  .modal-dialog {
    min-width: 325px;
  }
`;


const FormElement = ({ onDelete }: any) => {
  const { isLoading, show } = useTypedSelector((state: RootState) => state.jobFormDeleteSlice);
  const dispatch = useDispatch<AppDispatch>();


  const formik = useFormik({
    initialValues: initialValues,
    validateOnMount: false,
    validateOnChange: false,
    validationSchema: formSchema(null),
    onSubmit: values => {
      if(onDelete){
        onDelete(values?.remarks);
      }
  
      onCancel();
    },
  });
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = formik;


  const onCancel = () => {
    let form = { remarks: ''};
    setValues(form);
    dispatch(slice.setValues(form));
    dispatch(slice.setShow({ show: false }));
    dispatch(slice.resetSlice());
  }


  const setFooter = () => {
    return <Row className='gx-12 w-100'>
      <Col xs={true}></Col>
      <Col xs={'auto'}>
        <Button
          variant={'custom-outlined'}
          size={'sm'}
          disabled={isLoading}
          onClick={() => {
            onCancel();
          }}
        >Cancel</Button>
      </Col>
      <Col xs={'auto'}>
        <Button
          variant={'custom-danger'}
          size={'sm'}
          disabled={isLoading}
          onClick={() => {
            handleSubmit();
          }}
        >Yes, please remove</Button>
      </Col>
    </Row>
  }

  const setForm = () => {
    return <Row className={'g-16'}>
      {(checkStatus(values?.statusName, ['completed'])) && <Col xs={12}>
        <Alert
          className='mb-3'
          message={'Once you choose to delete a completed job, the details of the job will be removed from the maps and reports.'}
          description=""
          type="warning"
          showIcon
          icon={<AlertTriangleIcon />}
        />
      </Col>}

      <Col xs={12}>
        <Form.Group>
          {/* <Form.Label>{fields.remarks.label}</Form.Label> */}
          <Form.Control
            as="textarea"
            rows={fields.remarks.rows}
            autoComplete='off'
            placeholder={fields.remarks.placeholder}
            disabled={false}
            value={values.remarks}
            onChange={async (e) => {
              await setFieldValue('remarks', e.target.value);
            }}
            isInvalid={!!(errors && errors.remarks)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.remarks as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>
    </Row>
  }


  return <StyledModal
    className='wp-v5'
    show={show}
    onHide={() => {
      onCancel();
    }}
    backdrop={'static'}
    keyboard={false}
    enforceFocus={true}
    centered={true}
    size={'sm'}
  >
    <FormikContext.Provider value={formik}>
      <Modal.Header closeButton>
        <h6 className='fw-medium'>Are you sure you want to remove this job?</h6>
      </Modal.Header>

      <Spin spinning={isLoading} wrapperClassName={'no-height'}>
        <Modal.Body className='pt-24'>{setForm()}</Modal.Body>
      </Spin>

      <Modal.Footer className='px-12'>{setFooter()}</Modal.Footer>
    </FormikContext.Provider>
  </StyledModal>
}

export default FormElement;
